import { render } from "./AddGenericNotes.vue?vue&type=template&id=1b2d8022&ts=true"
import script from "./AddGenericNotes.vue?vue&type=script&lang=ts"
export * from "./AddGenericNotes.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__